import React from "react";
import { css } from "glamor";
import TipTapViewer from "../../library/TipTapViewer";
import { spacing } from "../../library/theme";

const wrapperClass = css({
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: spacing.m,
});

const baseCardClass = css({
  width: "85%",
  border: "0.66px solid #e2e8f0",
  background: "#f1f5f9",
  borderRadius: 12,
  padding: "11px 15px",
});

const incorrectCardClass = css({
  background: "#fff4f4",
  borderColor: "#fecaca",
});

const correctCardClass = css({
  background: "#f0fdf4",
  borderColor: "#bbf7d0",
});

const titleClass = css({
  fontWeight: 600,
  fontSize: 10,
  lineHeight: "15px",
  color: "#475569",
  marginBottom: spacing.xxs,
});

const contentClass = css({
  fontSize: 13,
  lineHeight: "22px",
  color: "#1e293b",
});

const statusRowBaseClass = css({
  marginTop: spacing.xs,
  display: "flex",
  alignItems: "center",
  gap: 5,
  fontWeight: 500,
  fontSize: 10,
  lineHeight: "15px",
});

const statusRowCorrectClass = css({ color: "#379c5c" });
const statusRowIncorrectClass = css({ color: "#c56262" });

const dotBaseClass = css({
  width: 6,
  height: 6,
  borderRadius: "50%",
  display: "inline-block",
});

const dotCorrectClass = css({ background: "#379c5c" });
const dotIncorrectClass = css({ background: "#c56262" });

const justificationBorderCorrectClass = css({
  borderTopColor: "#bbf7d0",
});

const justificationBorderIncorrectClass = css({
  borderTopColor: "#fecaca",
});

const justificationClass = css({
  marginTop: spacing.s,
  paddingTop: spacing.s,
  borderTop: "1px solid #e2e8f0",
  color: "#475569",
  fontSize: 11,
  lineHeight: "18px",
});

export default function AnswerFeedbackCard({
  selectedAlternative,
  isCorrect,
  revealResult,
}) {
  if (!selectedAlternative) return null;

  const cardColorClass = revealResult
    ? isCorrect
      ? correctCardClass
      : incorrectCardClass
    : null;

  return (
    <div className={wrapperClass} data-testid="answer-feedback-card">
      <div className={css(baseCardClass, cardColorClass)}>
        <div className={titleClass}>Sua resposta</div>
        <TipTapViewer content={selectedAlternative?.content} className={contentClass} />

        {revealResult && (
          <>
            <div
              data-testid="answer-feedback-status"
              data-correct={isCorrect ? "true" : "false"}
              className={css(
                statusRowBaseClass,
                isCorrect ? statusRowCorrectClass : statusRowIncorrectClass
              )}
            >
              <span
                className={css(
                  dotBaseClass,
                  isCorrect ? dotCorrectClass : dotIncorrectClass
                )}
              />
              <span>{isCorrect ? "Correta" : "Incorreta"}</span>
            </div>
            {selectedAlternative?.justification && (
              <TipTapViewer
                content={selectedAlternative.justification}
                className={css(
                  justificationClass,
                  isCorrect ? justificationBorderCorrectClass : justificationBorderIncorrectClass
                )}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
